import { useState, useEffect } from 'react';

const useOverloadedInputDropdown = (inputValueFormatted, values) => {
  const [overloadedCount, setOverloadedCount] = useState(0);

  useEffect(() => {
    if (!inputValueFormatted.endsWith('...')) {
      setOverloadedCount(0);
    } else {
      setOverloadedCount(values.length - inputValueFormatted.split(', ').length);
    }
  }, [inputValueFormatted, values.length]);

  return { overloadedCount };
};

export default useOverloadedInputDropdown;
